import { useGetOfflineDataPlatformsQuery } from "../redux/api/offlineData";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { theme } from "antd";
import { Skeleton } from "antd";
import { useCallback, useEffect, useState } from "react";

export const useSideNavOfflinePlatforms = () => {

  const [navItems, setNavItems] = useState([]);
  const navigate = useNavigate();
  const selectedClient = useSelector(
    (state) => state.genericReporting.selectedDropdownValues['client_name']
  );
  const selectedRegion = useSelector(
    (state) => state.genericReporting.selectedDropdownValues['client_region']
  );
    const { data, isFetching, isError } = useGetOfflineDataPlatformsQuery({
      clientName: selectedClient,
      clientRegion: selectedRegion
    });
  const { token } = theme.useToken();

  useEffect(
    () => {


      if (data) {
        const tmpPlatforms = data.map((platform) => {
            return {
              key: "/performance/marketing-reporting/" + platform,
              label: platform.charAt(0).toUpperCase() + platform.slice(1),
              onClick: () =>
                navigate(`/performance/marketing-reporting/${platform}`),
              style: {
                paddingLeft: token.subMenuIndent,
                animation: "fadeIn 1s",
              },
            };
        }
        );
        console.log('tmpPlatforms', tmpPlatforms)
        setNavItems(tmpPlatforms);
      }
    },
    [data, token.colorBgContainer]
  )

  if (isFetching) {
    return [
      {
        key: "-------",
        icon: <Skeleton.Button block active size="small" />,
      },
    ];
  }


  return (
    navItems
  )
};
